import { useSyncExternalStore } from "react";

/**
 * [ui1006, paczka KSC; sprawdzenie całości KSC/PROC 2026-10-07] PAMIĘĆ PULPITU — ostatnia odpowiedź źródła startu „pulpit”
 * (`GET /pulpit`), do kafli nagłówka huba, bloku „Spółki” startu i miejsc, które czytają pulpit z powłoki (N-12: miejsce nie woła
 * `GET /pulpit` drugi raz). Osobny plik, bo czyta go źródło startu z REJESTRU (`zrodlaStartu.js` → `config/obszary/wykazKsc.js`),
 * a rejestr stoi w paczce głównej — import z `daneWykazu.js` wciągał do niej hooki i komponenty miejsc.
 */
const sluchacze = new Set();
let ostatniPulpit = null;

/** Źródło startu „pulpit” zapisuje tu odpowiedź — start i hub czytają ją bez drugiego odczytu (sufit 3 — 2.5 pkt 10). */
export const zapamietajPulpit = (dane) => {
    ostatniPulpit = dane || null;
    sluchacze.forEach((f) => f());
};

export const wyczyscPamiecPulpitu = () => { ostatniPulpit = null; sluchacze.forEach((f) => f()); };

const zapisz = (f) => { sluchacze.add(f); return () => sluchacze.delete(f); };
const czytaj = () => ostatniPulpit;

/** Ostatnia odpowiedź `GET /pulpit` z powłoki (albo `null`, dopóki nie przyszła). */
export const usePamiecPulpitu = () => useSyncExternalStore(zapisz, czytaj, czytaj);
